import React from "react";
import { useNavigate } from "react-router-dom";

const PublicFooter = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-8 pt-6 border-t border-gray-200">
      <div className="flex flex-col sm:flex-row justify-between items-center text-sm text-gray-500">
        <div className="flex items-center space-x-4 mb-4 sm:mb-0">
          <span>© 2025 InProfile. All rights reserved.</span>
        </div>
        <div className="flex items-center space-x-6">
          <div
            className="hover:text-blue-600 cursor-pointer transition-colors"
            onClick={() => navigate("/contact-support")}
          >
            Contact Support
          </div>
          <div
            className="hover:text-blue-600 cursor-pointer transition-colors"
            onClick={() => window.open("/privacy-policy.html", "_blank")}
          >
            Privacy Policy
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicFooter; 